function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-171.000000, -998.000000)",
  fill: "#000E20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M170.203768,1000 L179.796232,1000 C180.348517,1000 180.796232,1000.44772 180.796232,1001 C180.796232,1001.24222 180.708314,1001.47621 180.548808,1001.6585 L175.752577,1007.13991 C175.388895,1007.55555 174.757132,1007.59767 174.341495,1007.23398 C174.308085,1007.20475 174.276658,1007.17332 174.247423,1007.13991 L169.451192,1001.6585 C169.087509,1001.24287 169.129627,1000.61111 169.545264,1000.24742 C169.727555,1000.08792 169.961545,1000 170.203768,1000 Z",
  transform: "translate(175.000000, 1004.000000) rotate(0) translate(-175.000000, -1004.000000) "
})));

var SvgListArrow = function SvgListArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "12px",
    viewBox: "0 0 8 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-arrow.f053ab49.svg";
export { ForwardRef as ReactComponent };